import React, { useState, useEffect } from "react";
import classnames from "classnames";

import { storage } from "../firebase";

const blankImg =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

const StorageImage = ({ path, alt, className, update=false, ...props }) => {
  const [src, setSrc] = useState(blankImg);
  useEffect(
    () => {
      storage()
        .ref(path)
        .getDownloadURL()
        .then(setSrc)
        .catch(err => {});
    },
    [path, update]
  );

  return (
    <img
      src={src}
      alt={alt}
      className={classnames("storage-image", className)}
      {...props}
    />
  );
};

export default StorageImage;
